export const DeleteLayerByType = `
    mutation deleteLayerByType ($type: String!) {
        deleteLayerByType (input: {type: $type}) {
            clientMutationId
            layer {
                layerId
                type
            }
        }
    }
`
